// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-jhs-free-final-confirm-stepnavi[data-v-f9453ba0]{margin:0 auto;padding:2.135vw 0;width:68.804664723%}.c-jhs-free-final-confirm-arrow[data-v-f9453ba0]::after{content:\" \";display:inline-block;width:2.135vw;height:4.27vw;background-image:url(/img/jhs_free/arrow_gray.png);background-size:contain;background-repeat:no-repeat;margin:0 2.135vw 0 6px;vertical-align:top}", ""]);
// Exports
module.exports = exports;
